import { QueryTarget, UpdateTargetBody } from "src/entity/target/target.entity";
import http from "../utils/http-common";

export const getTarget = (filter: QueryTarget) => {
  return http.get(`/api/target`, { params: filter });
};

export const updateTarget = (body: UpdateTargetBody) => {
  return http.put(`/api/target`, body);
};
